import React, { useState } from 'react'
import { Button, Col, Form, Icon, Input, Row, Upload } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import _, { isNull } from 'lodash'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'
import axios from 'axios'

const DocProfile = ({ form, onOk, onCancel, formData }) => {
  const { setFieldsValue, getFieldDecorator, validateFields } = form
  const [imageUrl, setImageUrl] = useState('')

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        detail: formData.detail,
        name: formData.name
      })
      setImageUrl(formData.image)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
    }
  }, [formData])

  async function uploadDocImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const token = localStorage.getItem('user-token')
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/document/image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: !_.isNull(token) ? token : ''
          }
        }
      )

      return res.data
    } catch (err) {
      return null
    }
  }

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          detail: values.detail,
          name: values.name
        }

        if (values.image) {
          const img = await uploadDocImage(values.image.file)
          data.image = img.url
        }else{
          data.image = formData.image
        }
        if (!_.isEmpty(formData)) {
          data.docId = formData.docId
        }
        onOk(data)
        setImageUrl('')
      }
    })
  }

  return (
    <Form onSubmit={onSubmit} layout="vertical">
      <Form.Item label="Document Image">
        {getFieldDecorator(`image`, {
          rules: [
            {
              required: isNull(formData),
              message: 'เลือกรูปภาพ'
            }
          ]
        })(
          <Upload
            name="img"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={(file) => beforeUpload(file)}
            onChange={handleChange}>
            {imageUrl ? (
              <img src={imageUrl} alt="img" style={{ width: '100%' }} />
            ) : (
              uploadButton
            )}
          </Upload>
        )}
      </Form.Item>
      <Form.Item label="Document Name">
        {getFieldDecorator(`name`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label="Document Description">
        {getFieldDecorator(`detail`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<Input.TextArea autoSize={{ minRows: 10 }} />)}
      </Form.Item>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ยกเลิก</Button>
        </Col>
        <Col>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            บันทึก
          </ButtonEx>
        </Col>
      </Row>
    </Form>
  )
}

const WrappedDocProfile = Form.create({ name: 'DocProfile' })(DocProfile)
export default WrappedDocProfile